import type { SVGProps } from "react";
export interface BagelIconProps
  extends Omit<SVGProps<SVGSVGElement>, "width" | "height"> {
  className?: string;
  size?: number;
  color?: string;
}
export function BagelIcon({
  className = "",
  size = 24,
  color = "currentColor",
  ...props
}: BagelIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 24 24"
      className={className}
      {...props}
    >
      <path
        fill={color}
        d="M10.205 18.205a1.125 1.125 0 0 1 1.59 1.59l-1 1a1.125 1.125 0 0 1-1.59-1.59zm6-3a1.125 1.125 0 0 1 1.505-.078l.086.078.999 1 .078.085a1.126 1.126 0 0 1-1.582 1.582l-.087-.076-.999-1-.078-.086a1.125 1.125 0 0 1 .078-1.505M5.5 13.875l.116.005a1.126 1.126 0 0 1 0 2.239l-.116.006H4a1.125 1.125 0 0 1 0-2.25zm.705-7.67a1.125 1.125 0 1 1 1.59 1.59l-1 1a1.125 1.125 0 0 1-1.59-1.59zm13.295.67.115.006a1.125 1.125 0 0 1 0 2.239l-.115.005H18a1.126 1.126 0 0 1 0-2.25zm-7.295-3.67a1.125 1.125 0 0 1 1.505-.078l.085.078 1 1 .077.085a1.125 1.125 0 0 1-1.582 1.582l-.085-.076-1-1-.078-.086a1.125 1.125 0 0 1 .078-1.505"
      />
      <path
        fill={color}
        d="M20.875 12a8.875 8.875 0 1 0-17.75 0 8.875 8.875 0 0 0 17.75 0m-7 0a1.875 1.875 0 1 0-3.75.001 1.875 1.875 0 0 0 3.75 0Zm2.25 0a4.126 4.126 0 1 1-8.251 0 4.126 4.126 0 0 1 8.252.002Zm7 0c0 6.144-4.98 11.124-11.124 11.125S.875 18.145.875 12 5.856.875 12.001.875c6.143 0 11.124 4.981 11.124 11.126Z"
      />
    </svg>
  );
}
